var map = {
	"./20-minuten.svg": 45,
	"./20min-blick.svg": 46,
	"./aarau24.svg": 47,
	"./andelfinger.svg": 48,
	"./berner_oberlaender-thuner_tagblatt.svg": 49,
	"./berner_oberlaender.svg": 50,
	"./bernerzeitung.svg": 51,
	"./bieler-tagblatt.svg": 52,
	"./blick.svg": 53,
	"./engadiner-post.svg": 54,
	"./frutiglaender.svg": 55,
	"./jurep.svg": 56,
	"./maz.svg": 57,
	"./maz_old.svg": 58,
	"./medieninstitut.svg": 15,
	"./missing.svg": 10,
	"./nzz-am-sonntag.svg": 59,
	"./nzz.svg": 60,
	"./pctipp.svg": 61,
	"./persoenlich.svg": 62,
	"./r4tng.svg": 63,
	"./radio-24.svg": 64,
	"./radio-32.svg": 65,
	"./radio-argovia.svg": 66,
	"./radio-fm1.svg": 67,
	"./radio-pilatus.svg": 68,
	"./rsn.svg": 69,
	"./rsn_old.svg": 70,
	"./sda.svg": 71,
	"./shn.svg": 72,
	"./sonntagszeitung.svg": 73,
	"./srf-10vor10-tagesschau.svg": 74,
	"./srf-10vor10.svg": 75,
	"./srf-3.svg": 76,
	"./srf-arena.svg": 77,
	"./srf-club.svg": 78,
	"./srf-einstein.svg": 79,
	"./srf-kassensturz.svg": 80,
	"./srf-myschool.svg": 81,
	"./srf-news.svg": 82,
	"./srf-schweiz_aktuell.svg": 83,
	"./srf-schweizaktuell.svg": 84,
	"./srf-tagesschau.svg": 85,
	"./srf.svg": 86,
	"./suedostschweiz.svg": 87,
	"./ta-blick-srf.svg": 88,
	"./ta-sz.svg": 89,
	"./tagesanzeiger.svg": 90,
	"./thuner_tagblatt.svg": 91,
	"./tv4tng.svg": 92,
	"./vaterland.svg": 93,
	"./videogang.svg": 94,
	"./virgin.svg": 95,
	"./virus.svg": 96,
	"./volksstimme.svg": 97,
	"./vsm.svg": 98,
	"./watson.svg": 99,
	"./zhaw.svg": 100,
	"./zolliker_bote.svg": 101,
	"./zueritipp.svg": 102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9;